export default __webpack_public_path__ + "static/5-318221fa8360b7d20a9d1e4d24139df6.jpeg";